export default __webpack_public_path__ + "339b8a9e.svg";